function Inspirtations() {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center gap-4 lg:gap-8 xl:gap-12 py-[5vh] xl:py-[10vh] 2xl:py[15vh] px-[5vw] xl:px-[8vw] opacity-0 animate-zoom-in text-justify text-brun-contrast">
            <h1 className="font-semibold text-center text-brun-main text-xl md:text-2xl">Oups..</h1>
            <div className="flex gap-2">
              <div className="h-2 w-2 md:h-3 md:w-3 2xl:h-4 2xl:w-4 rounded-full bg-brun-main/80 animate-bounce [animation-delay:-0.3s]" />
              <div className="h-2 w-2 md:h-3 md:w-3 2xl:h-4 2xl:w-4 rounded-full bg-brun-main/80 animate-bounce [animation-delay:-0.15s]" />
              <div className="h-2 w-2 md:h-3 md:w-3 2xl:h-4 2xl:w-4 rounded-full bg-brun-main/80 animate-bounce" />
            </div>

            <p className="text-center text-lg md:text-xl">On dirait que votre page <strong>Inspirations</strong> est en cours de construction</p>
        </div>
    )
}

export default Inspirtations;